import { render } from "./ProjectTryItContent.vue?vue&type=template&id=61c97a00"
import script from "./ProjectTryItContent.vue?vue&type=script&lang=js"
export * from "./ProjectTryItContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__